import { isSameYear } from 'date-fns';
import { convertZonedDateToSystemDate } from './DateUtils2.js';
import { gregorianToHijri } from './DateUtils38.js';

const getTzIsSameYear = (tzDateLeft, tzDateRight, calendar = 'gregorian') => {
    const systemLeftDate = convertZonedDateToSystemDate(tzDateLeft);
    const systemRightDate = convertZonedDateToSystemDate(tzDateRight);
    if (calendar === 'gregorian')
        return isSameYear(systemLeftDate, systemRightDate);
    return gregorianToHijri(systemLeftDate).year === gregorianToHijri(systemRightDate).year;
};

export { getTzIsSameYear };
